// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../web/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../web/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/SF-Pro-Display-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/SF-Pro-Display-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/SF-Pro-Display-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/SF-Pro-Display-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/SF-Pro-Display-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: 'Inter';
  src: local('Inter'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
    font-family: 'Inter';
    font-weight: 900;
    src: local('Inter'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}

@font-face {
    font-family: 'Inter';
    font-weight: 900;
    src: local('Inter'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
}

@font-face {
  font-family: 'Inter';
  font-weight: 900;
  src: local('Inter'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
}
@font-face {
  font-family: 'Inter';
  font-weight: 900;
  src: local('Inter'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
}
`, "",{"version":3,"sources":["webpack://./../app/src/App.css"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,+EAAmF;AACrF;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,+EAAuF;AAC3F;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,+EAAsF;AAC1F;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,+EAAmF;AACrF;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,+EAAqF;AACvF","sourcesContent":["\n@font-face {\n  font-family: 'Inter';\n  src: local('Inter'), url(./assets/fonts/SF-Pro-Display-Bold.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Inter';\n    font-weight: 900;\n    src: local('Inter'), url(./assets/fonts/SF-Pro-Display-Semibold.otf) format('opentype');\n}\n\n@font-face {\n    font-family: 'Inter';\n    font-weight: 900;\n    src: local('Inter'), url(./assets/fonts/SF-Pro-Display-Regular.otf) format('opentype');\n}\n\n@font-face {\n  font-family: 'Inter';\n  font-weight: 900;\n  src: local('Inter'), url(./assets/fonts/SF-Pro-Display-Thin.otf) format('opentype');\n}\n@font-face {\n  font-family: 'Inter';\n  font-weight: 900;\n  src: local('Inter'), url(./assets/fonts/SF-Pro-Display-Medium.otf) format('opentype');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
